module.exports = __webpack_public_path__ + "img/agentes.810c0e3c.png";